import { makeNoteMockData } from '../../modules/noteMockDataFactory'
import type { IContractNote } from '~/types/note/models'

export const {
  getNoteListData: getContractNoteListData,
  getNoteDataById: getContractNoteDataById,
  getNoteListDataByParentId: getContractNoteListDataByContractId,
} = makeNoteMockData<IContractNote>({
  entityName: 'contract',
  storageKeyPrefix: 'contract',
})
